import { z } from "zod";

export const EditSalonAppointmentFormSchema = z.object({
  employee: z.string().uuid({ message: "Colaborador(a) inválido" }),
  datetime: z.date({ message: "Data inválida" }),
  service: z.string({ message: "Serviço inválido" }),
});
